import Vue from 'vue'
import Vuex from 'vuex'
import vueAuthInstance from '../service/auth.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isAuthenticated: vueAuthInstance.isAuthenticated(),
    user: {},
    myArray: []
  },

  getters: {
    isAuthenticated() {
      return vueAuthInstance.isAuthenticated()
    },
    user(state) {
      return state.user
    },
    myArray(state) {
      return state.myArray
    }
  },

  mutations: {
    isAuthenticated(state, payload) {
      state.isAuthenticated = payload.isAuthenticated
    },
    user(state, payload) {
      state.user = payload
    },
    setMyArray(state, payload) {
      state.myArray = payload
    }
  },

  actions: {
    login(context, payload) {
      payload = payload || {}
      return vueAuthInstance
        .login(payload.user, payload.requestOptions)
        .then(function (response) {
          if (response.status === 200) {
            context.commit('isAuthenticated', {
              isAuthenticated: vueAuthInstance.isAuthenticated()
            })
            context.commit('user', response.data.data.user_info)
            return response
          }
          return response
        })
        .catch(error => {
          return error.response
        })
    },

    logout(context, payload) {
      payload = payload || {}
      return vueAuthInstance
        .logout(payload.requestOptions)
        .then(function (response) {
          console.info(response)
          context.commit('isAuthenticated', {
            isAuthenticated: vueAuthInstance.isAuthenticated()
          })
          context.commit('user', {})
          localStorage.clear()
        })
        .catch(error => {
          console.error(error)
          context.commit('isAuthenticated', false)
          context.commit('user', {})
          localStorage.clear()
        })
    },

    authenticate(context, payload) {
      payload = payload || {}
      return vueAuthInstance
        .authenticate(
          payload.provider,
          payload.userData,
          payload.requestOptions
        )
        .then(
          response => {
            console.info(response)
            context.commit('isAuthenticated', {
              isAuthenticated: vueAuthInstance.isAuthenticated()
            })
          },
          response => {
            console.info(response)
          }
        )
    },

    setUser(context, payload) {
      console.info(payload)
      payload = payload || {}
      if (context.getters.isAuthenticated) {
        return Vue.axios
          .get(process.env.VUE_APP_API_URL + '/auth/user-info')
          .then(response => {
            if (response.status == 200) {
              context.commit('user', response.data.data.user_info)
              return response
            }
            return response
          })
      } else {
        context.commit('user', {})
      }
    },
    setMyArray(context, payload) {
      context.commit('setMyArray', payload)
    }
  }
})

export default store
